<template>
  <!-- <div> -->
  <div id="app" ref="App">
    <div class="FondoTriangulos">
      <div class="w100 aliCenter h100 dIB">
        <div class="Triangulo1"></div>
        <!-- <img src="./assets/gbTriangulo1.png" alt="" class="Triangulo1"> -->
        <div class="Triangulo2"></div>
        <!-- <img src="./assets/gbTriangulo1.png" alt="" class="Triangulo2"> -->
      </div>
    </div>

    <div class="bgImageContainer" v-if="BgImage != ''">
      <div :class="`bgImage ${BgImage}`"></div>
    </div>
    <div class="FondoVistas" v-show="loggedUser"></div>

    <!-- <div id="nav">
        <router-link to="/">Home</router-link> |
        <router-link to="/about">About</router-link>
      </div>-->
    <router-view />
    <!-- <GUI v-show="true"></GUI> -->

    <GUI v-if="loggedUser" />

    <notifications group="Notificaciones" position="bottom right" />
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>

  <!-- <div class="MdoOffline"></div>
  </div> -->
</template>

<script>
import axios from "axios";
import Clases from "./Auxiliares/Clases.js";
import ManejoDatos from "./Auxiliares/ManejoDatos.js";
import GUI from "./components/GUI.vue";
import { Herramientas } from "./Auxiliares/Enums";
// import router from './router/Router.js';

export default {
  name: "App",
  data() {
    return {
      Datos: {
        _IP: "",
        _User: null,
        AdminLogueado() {
          var _Retorno = false;
          if (this._User != null) {
            _Retorno = this._User._RolUsuario == 99;
          }
          return _Retorno;
        },
        KeyUser() {
          return Clases.KeyUser;
        },
        LogOff(_Router) {
          Clases.EliminarJsonDelStorage(this.KeyUser());
          //window.location.href = "./login";
          _Router.push("/login");
          this._User = null;
        },
        ChequearSesionUsuario(_Router) {
          var _Retorno = true;
          this._User = Clases.GetUserLogged();
          if (this._User == null) {
            if (_Router.currentRoute.path != "/login") {
              _Retorno = false;
              _Router.push("/login");
            }
          }
          return _Retorno;
        },
        AppOnline() {
          return navigator.onLine;
        },
      },
      BgImage: ""
    };
  },
  // async beforeMount(){
  //   this._IP = await ManejoDatos.MiIP();
  //   console.log(1);
  // },
  async mounted() {
    if(this.$route.query.vermapaa){
      this.$router.push("/vermapa?t=" + this.$route.query.vermapaa);
    }else{
      this.Datos.ChequearSesionUsuario(this.$router);
    }
    ManejoDatos.IniciarProcesoSincronizaciones(this);
    this.SetBgImage();
  },
  watch:{
    $route (to, from){
      this.SetBgImage();
    }
  },
  components: {
    GUI,
  },
  methods: {
    LoginCorrecto(_User) {
      this.Datos._User = _User;
      //this.SolicitarProductores();
    },
    SolicitarProductores() {
      var _Parametro = 0;
      if (this.Datos._User._RolUsuario != 99) {
        _Parametro = this.Datos._User._Id;
      }
      var _This = this;
      axios
        .post(_This.urlPosts + "/manolo/productores", {
          IdProductor: _Parametro,
        })
        .then(function (response) {
          let _Retorno = response.data;
          if (_Retorno.length > 0) {
            _This.Datos._Productores = _Retorno;
          } else {
            alert("No se encontraron productores");
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {});
    },
    Notificacion(_Titulo, _Body, _Tipo, _Segundos) {
      if (_Tipo == "") {
        _Tipo = "success";
      }
      this.$notify({
        group: "Notificaciones",
        title: _Titulo, //Puede ser HTML
        type: _Tipo, //alert celeste, success verde
        speed: 500,
        duration: _Segundos * 1000,
        text: _Body, //Puede ser HTML
      });
    },
    SetBgImage(){
      this.BgImage = "";
      let IdHerramientaSeccion = Herramientas.GetIdHerramientaByRouteName(this.$router.currentRoute.name);
      if (IdHerramientaSeccion > 0)
        this.BgImage = `bgImage${IdHerramientaSeccion}`;
      if (this.$router.currentRoute.name == "Home")
        this.BgImage = `bgImage0`;
    }
  },
  computed: {
    loggedUser(){
      if (this.Datos._User != null) return true;
      return false;
    }
  }
};
</script>

<style lang="scss">
@import "./Css/Globales.css";
@import "./Css/AgroIdeas.scss";
@import "./Css/Componentes.scss";
$AgroIdeasBotones: #4ba05d;
.FondoVistas {
  background-color: rgba(255, 255, 255, 0.7);
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  width: 100vw;
  width: 100%;
  //max-width:800px;
  min-height: 100vh;
  display: block;
  font-size: 20px;
}
.fs12em {
  font-size: 1.2em;
}
.FondoVistas {
  background-color: $AgroIdeas;
  background-color: rgba(255, 255, 255, 0.8);
  height: 100%;
  width: 100%;
  position: fixed;
  overflow: hidden;
  z-index: -1;
  display: block;
}
.bgImageContainer{
  height: 100%;
  width: 100%;
  position: fixed;
  overflow: hidden;
  z-index: -1;
  display: block;
}
.bgImage {
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bgImage0{background-image: url("./assets/bgTools/0.png");}
.bgImage1{background-image: url("./assets/bgTools/1.png");}
.bgImage2{background-image: url("./assets/bgTools/2.png");}
.bgImage3{background-image: url("./assets/bgTools/3.jpg");}
.bgImage4{background-image: url("./assets/bgTools/4.png");}
.bgImage5{background-image: url("./assets/bgTools/5.png");}
.bgImage6{background-image: url("./assets/bgTools/6.png");}
.bgImage7{background-image: url("./assets/bgTools/3.jpg");}//TODO:(!) completar
.bgImage8{background-image: url("./assets/bgTools/8.png");}
.bgImage9{background-image: url("./assets/bgTools/9.png");}
.bgImage10{background-image: url("./assets/bgTools/10.png");}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.Contenido {
  min-height: 100vh;
}
.IconoAgregar,
.IconoEliminar {
  cursor: pointer;
  width:30px;padding:0 5px;
}

// .vue-notification-group{
//   // width:250px !important;
//   // right:5px !important;
// }
.vue-notification {
  padding: 10px;
  margin: 0 5px 5px;
  // width:250px;

  font-size: 12px;

  color: #ffffff;
  // background: #0d6b29;
  // border-left: 5px solid #00ad34;

  &.warn {
    background: #92692c !important;
    border-left-color: #f48a06 !important;
  }

  &.error {
    background: #e54d42;
    border-left-color: #b82e24;
  }

  &.success {
    // background: #0d6b29;
    // border-left: 5px solid #00ad34;
    background: #00ad34 !important;
    border-left-color: #008f2b !important;
  }
}
</style>
